import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import RolesListTopbar from "../../features/manageSubAdmin/rolesTopbar";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { showError, showToast } from "../../constants/toasts";
import { useEffect, useState } from "react";
import { useLazyChangeRoleStatusQuery, useLazyDeleteRoleQuery, useLazyGetRolesQuery } from "../../service/subAdmin";
import IosSwitchMain from "../../components/iosSwitchMain";
import { Role } from "../../types/General";
import { formatDubaiDateTime } from "../../utils/dateTime";
import CustomPagination from "../../components/CustomPagination";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import Loader from "../../constants/Loader";
const ManageSubadminRoles = () => {

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  const [getRoles] = useLazyGetRolesQuery()
  const [deleteApi] = useLazyDeleteRoleQuery()
  const [changeRoleStatus] = useLazyChangeRoleStatusQuery()

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(10);
  const [roles, setRoles] = useState<Role[]>([]);
  const [selectedId, setSelectedId] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);


  const handleDelete = async (id: string) => {
    try {
      const response = await deleteApi({
        id,
      }).unwrap();
      if (response.status === 200) {
        getRolesApi();
        showToast(response?.message);
      } else {
        showError(response?.message);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const changeRoleStatusApi = async (id: string) => {
    try {
      const response = await changeRoleStatus({ id }).unwrap();
      if (response.status === 200) {
        getRolesApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };


  const getRolesApi = async () => {
    setLoading(true);
    try {
      const response = await getRoles({
        search: debouncedSearchTerm.trim(),
        page,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setRoles(response?.data?.roles || []);
        setCount(response?.data?.total);
      } else {
        setRoles([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };


  useEffect(() => {
    getRolesApi();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>

      <Loader isLoad={loading} />

      <div className="main_title d_flex">
        <h1 className="back_arrow">      <IconButton onClick={() => goBack()}>
          {" "}
          <ArrowBackIcon />{" "}
        </IconButton> Manage Roles</h1>
        <div className="right_s">
          <RolesListTopbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} setDebouncedSearchTerm={setDebouncedSearchTerm} />
        </div>
      </div>

      <div className="cards table_cards v2">

        <TableContainer sx={{ mt: 4 }} className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Role Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {roles?.length ? roles?.map((row) => (
                <TableRow key={row?.roleId}>
                  <TableCell>
                    <div
                      className="user_block click_action"
                      onClick={() => navigate(`/manage-subadmin/roles/detail/${row?.roleId}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <p>
                        <b>{row?.roleName || ''}</b>
                      </p>
                    </div>
                  </TableCell>

                  <TableCell>{row?.createdDate ? formatDubaiDateTime(row?.createdDate) : "-"}</TableCell>

                  <TableCell align="center">
                    <IosSwitchMain
                      checked={row?.isActive}
                      onChange={() => changeRoleStatusApi(row?.roleId)}
                    />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton
                          onClick={() => navigate(`/manage-subadmin/roles/edit/${row?.roleId}`)}
                        >
                          <img src="/static/images/edit2_icon.svg" alt="edit" />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton onClick={() => {
                          setOpenDelete(true);
                          setSelectedId(row?.roleId);
                        }}>
                          <img src="/static/images/trash2_icon.svg" alt="delete" />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              )) : hasFetched ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>

          </Table>

        </TableContainer>

      </div>
      {roles?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}

      <ConfirmationModal
        text={"Are you sure to delete this Role?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => {
          handleDelete(selectedId);
        }}
      />
    </MainContainer>
  );
};

export default ManageSubadminRoles;
